import React from 'react';

/**
 * Referência estável: o Quill injeta SVGs nos botões após montar.
 * Recriar estes elementos a cada render apaga os ícones.
 */
const HEADER_EDITOR = (
    <>
        <span className="ql-formats">
            <button type="button" className="ql-bold" aria-label="Bold"></button>
            <button type="button" className="ql-italic" aria-label="Italic"></button>
            <button type="button" className="ql-underline" aria-label="Underline"></button>
        </span>
        <span className="ql-formats">
            <button type="button" className="ql-list" value="ordered" aria-label="Ordered List"></button>
            <button type="button" className="ql-list" value="bullet" aria-label="Unordered List"></button>
        </span>
    </>
);

export const renderHeaderEditor = () => HEADER_EDITOR;